export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
export const MOUSEFLOW_ANALYTICS_ID =
  process.env.REACT_APP_MOUSEFLOW_ANALYTICS_ID;
export const GOOGLE_TAG_MANAGER_ID =
  process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
